import { useMutation } from '@tanstack/react-query';
import { getSearchData } from '../../api/search/getSearchData';

export const useGetSearchData = () => {
  const { data, isSuccess, mutate, isPending } = useMutation({
    mutationKey: ['getSearchData'],
    mutationFn: (phrase: string) => getSearchData(phrase),
  });

  return {
    searchDataMutate: mutate,
    searchData: data,
    isGetSearchDataSuccess: isSuccess,
    isGetSearchDataPending: isPending,
  };
};
